module.exports = __webpack_public_path__ + "img/succeed.da462a80.png";